module.exports = __webpack_public_path__ + "static/media/blackArrowUp.22732d10.svg";